import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import TmpSpinnerCustom from "../TmpSpinnerCustom/TmpSpinnerCustom";
import { Button, Notification } from "./Style";
import { style } from "./StyleType";

interface TmpButtonIconCustomProps {
    type: "primary" | "secondary";
    typeButton: "submit" | "button";
    size: "sm" | "lg";
    disabled?: boolean;
    loading?: boolean;
    startIcon?: any;
    notification?: boolean,
    notificationValue?: string,
    id?: string;
    handleClick: () => void;
    ariaLabel?: string;
    tabIndex?: string;
    icon: React.ReactElement;
}

export default function TmpButtonIconCustom(props: TmpButtonIconCustomProps) {

    // Passing style props to styled component
    Button.defaultProps = style;
    Notification.defaultProps = style;
    // Spinner.defaultProps = style;

    if (props.loading) {
        return (
            <Button
                id={props.id}
                className="tmp-button-icon"
                data-testid="button"
                size={props.size}
                disabled={props.disabled}
                onClick={props.handleClick}
                type={props.typeButton}
                variant={props.type}
                aria-label={props.ariaLabel}
            // tabIndex={props.tabIndex}

            >
                <TmpSpinnerCustom />
            </Button>
        );
    }
    return (
        <Button
            id={props.id}
            className="tmp-button-icon"
            data-testid="button"
            size={props.size}
            disabled={props.disabled}
            onClick={props.handleClick}
            type={props.typeButton}
            aria-label={props.ariaLabel}
            variant={props.type}

        >
            <TmpIconCustom icon={props.icon} size={props.size === "sm" ? "sm" : "md"} />
            {props.notification && props.size === "lg" && (
                <Notification disabled={props.disabled ? true : false}>{props.notificationValue}</Notification>
            )}
        </Button>
    );

}